module.exports = __webpack_public_path__ + "0affccd99f63cb55d384bd0a7167c56f.jpg";